import { BCMSCurrency, BCMSRecord, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultMultiPay, getWorkflowSteps } from "compid/workflows/MultiPay";
import { Bill, Payment } from "model";

import MultipayWidget, { MultiPayAmountItem } from "compid/shared/widgets/MultipayWidgets";

export default function SchedulePaymentsMultipay(props) {
    // Initalize the workflowStep
    const workflowStep = useWorkflowStep(getDefaultMultiPay, getWorkflowSteps);
    const items = workflowStep.read("items");
    // For each item in state, set the amount of the bill equal to the item amount
    const bills = items.map(item => {
        const bill = Bill.initByID(item.bill.id);
        bill.amount = item.amount ?? BCMSCurrency.init(0);
        bill.hasFee = item._hasFee;
        bill.feeAmount = item.feeAmount;

        return bill;
    }, []);
    // For each bill create a MultiPayAmountItem component
    const billItems = bills.map(bill =>  <MultiPayAmountItem key={ `Multipay_${ bill.id }` } bill={ bill } />, []);

    const cancel = evt => workflowStep.navigate("/payBills");
    const submit = evt => {
        // For each item in state create the payment and bill update functions
        const updates = items.reduce((result, item, index) => {
            const bill = item.bill;
            const payment = item.payment;
            // Add a fee amount if theres any. No fee would be "0", so the amount is unaffected.
            //item.amount = parseFloat(item.amount.amount ?? 0) + parseFloat(item.feeAmount.amount ?? 0);
            payment.amount = parseFloat(item.amount.amount ?? 0) + parseFloat(item.feeAmount.amount ?? 0);

            payment.id = parseFloat(payment.id) + index;

            bill.status = "scheduled";
            bill.payment = payment;

            return [ ...result, Payment.create(payment), Bill.update(bill) ];
        }, []);
        // Batch updates to model and continue to the next step in the workflow
        BCMSRecord.batch(updates, workflowStep.globalController);        
        workflowStep.workflow.nextStep(workflowStep.getStepState);
    };

    return (
        <MultipayWidget
            bills={ bills }
            items={ billItems }
            onCancel={ cancel }
            onSubmit={ submit }
        />
    );
}